import { getAxiosClient } from "../../axios-client";
import { ForgottenPasswordUpdateRequestBody, ForgottenPasswordUpdateResponse } from "./types";
const axiosClient = getAxiosClient();

export const forgottenPasswordUpdate = async (body: ForgottenPasswordUpdateRequestBody) => {
    return await axiosClient.ax.put<ForgottenPasswordUpdateResponse>(`/Account/ForgottenPasswordUpdate/${body.token}`, { haslo: body.haslo });
};
